<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-btn text @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="5" md="12">
        <v-card class="ui-module-card ui-module-fade-in-up summary-card" color="secondary" elevation="8">
          <v-card-title class="font-weight-bold justify-center ui-module-titlebar mb-5">
            Información de evaluaciones de desempeño
          </v-card-title>
          <v-card-text class="summary-card-text">
            <v-row>
              <v-col cols="12" class="summary-row">
                <v-icon color="secondary" left>mdi-calendar</v-icon>
                <span class="font-weight-bold info-label">Fecha evaluación de desempeño académico:</span>
                <span class="ml-2 info-value">
                  {{ latestEvaluacionAcademicaDate ? formatFecha(latestEvaluacionAcademicaDate) : 'Sin registro' }}
                </span>
              </v-col>
              <v-col cols="12" class="summary-row">
                <v-icon color="secondary" left>mdi-note-check</v-icon>
                <span class="font-weight-bold info-label">Calificación evaluación de desempeño académico:</span>
                <span class="ml-2 info-value">{{ latestEvaluacionAcademicaCalificacion || 'Sin registro' }}</span>
              </v-col>
            </v-row>
            <v-divider class="my-4 mx-0 summary-divider"></v-divider>
            <v-row>
              <v-col cols="12" class="summary-row">
                <v-icon color="secondary" left>mdi-calendar-check</v-icon>
                <span class="font-weight-bold info-label">Fecha evaluación de desempeño:</span>
                <span class="ml-2 info-value">
                  {{ latestEvaluacionDesempenioDate ? formatFecha(latestEvaluacionDesempenioDate) : 'Sin registro' }}
                </span>
              </v-col>
              <v-col cols="12" class="summary-row">
                <v-icon color="secondary" left>mdi-note-check</v-icon>
                <span class="font-weight-bold info-label">Calificación evaluación de desempeño:</span>
                <span class="ml-2 info-value">{{ latestEvaluacionDesempenioCalificacion || 'Sin registro' }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="card mt-4" color="primary" elevation="4">
          <v-card-title class="d-flex align-center pb-0">
            <span class="font-weight-bold">Historial de CUPs</span>
            <v-spacer></v-spacer>
            <v-chip v-if="cups.length > 0" color="secondary" class="primary--text font-weight-bold" small>
              {{ cups.length }}
            </v-chip>
          </v-card-title>
          <v-card-text class="pa-2">
            <div v-if="loadingCups" class="text-center py-4">
              <v-progress-circular indeterminate color="secondary" size="32"></v-progress-circular>
            </div>
            <v-virtual-scroll
              v-else-if="cups.length > 0"
              :height="cups.length > 3 ? 280 : cups.length * 88"
              :items="cups"
              item-height="88"
            >
              <template v-slot:default="{ item, index }">
                <v-list-item :key="index" two-line class="px-1">
                  <v-list-item-avatar color="secondary" size="36">
                    <span class="primary--text font-weight-bold text-caption">{{ index + 1 }}</span>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold secondary--text text-subtitle-2">
                      {{ item.cup || 'Sin número' }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="d-flex align-center mt-1">
                      <v-icon x-small left color="secondary">mdi-calendar</v-icon>
                      <span class="text-caption">Fecha de vigencia: {{ item.vigenciaCup || 'Sin vigencia' }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="index < cups.length - 1" class="mx-2"></v-divider>
              </template>
            </v-virtual-scroll>
            <div v-else class="text-center py-4">
              <v-icon size="36" color="secondary">mdi-shield-off-outline</v-icon>
              <div class="text-caption mt-1 grey--text">Sin CUPs registrados.</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="7" md="12">
        <v-card class="ui-module-card ui-module-fade-in-up mx-2" color="primary">
          <v-card-title class="font-weight-bold justify-center ui-module-titlebar">Asignación de CUP</v-card-title>
          <v-card-text class="cup-form-shell">
            <v-text-field
              :value="getFullName(personal)"
              class="ui-form-field mt-2"
              rounded
              filled
              dense
              background-color="transparent"
              color="secondary"
              label="Nombre del elemento"
              :rules="nameRules"
              readonly
            ></v-text-field>
            <v-text-field
              :value="personal ? personal.CUIP : ''"
              class="ui-form-field"
              rounded
              filled
              dense
              background-color="transparent"
              color="secondary"
              label="CUIP"
              :rules="nameRules"
              readonly
            ></v-text-field>
            <v-text-field
              v-model="cup"
              class="ui-form-field"
              rounded
              filled
              dense
              background-color="transparent"
              color="secondary"
              :rules="nameRules"
            >
              <template v-slot:label>Ingrese número de CUP <span class="red--text">*</span> </template>
            </v-text-field>
            <v-file-input
              v-model="file"
              class="ui-form-field"
              rounded
              filled
              background-color="transparent"
              color="secondary"
              dense
              accept=".pdf"
              :rules="nameRules"
            >
              <template v-slot:label>Adjuntar documento CUP <span class="red--text">*</span> </template>
            </v-file-input>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="fechaEmisionEvaluacionC3"
                  v-mask="'##/##/####'"
                  class="ui-form-field"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  :rules="dateRules"
                >
                  <template v-slot:label
                    >Fecha de emisión de evaluaciones C3 <span class="red--text">*</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="vigenciaEvaluacionC3Calculada"
                  v-mask="'##/##/####'"
                  class="ui-form-field"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  label="Vigencia de evaluaciones C3"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="fechaEmisionFormacionInicial"
                  v-mask="'##/##/####'"
                  class="ui-form-field"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  :rules="dateRules"
                >
                  <template v-slot:label
                    >Fecha de emisión de formación inicial <span class="red--text">*</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="vigenciaFormacionInicialCalculada"
                  v-mask="'##/##/####'"
                  class="ui-form-field"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  label="Vigencia de formación inicial"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="fechaEmisionCompetenciasBasicas"
                  v-mask="'##/##/####'"
                  class="ui-form-field"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  :rules="dateRules"
                >
                  <template v-slot:label
                    >Fecha de emisión de competencias básicas <span class="red--text">*</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="vigenciaCompetenciasBasicasCalculada"
                  v-mask="'##/##/####'"
                  class="ui-form-field"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  label="Vigencia de competencias básicas"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="fechaEmisionCup"
                  v-mask="'##/##/####'"
                  class="ui-form-field"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  :rules="dateRules"
                >
                  <template v-slot:label>Fecha de emisión de CUP <span class="red--text">*</span> </template>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :value="vigenciaCupCalculada"
                  v-mask="'##/##/####'"
                  class="ui-form-field"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="transparent"
                  label="Vigencia de CUP"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-center pb-8 ui-module-actions">
            <v-btn
              class="ui-module-btn-text-danger"
              v-bind="secondaryButtonProps"
              to="/desarrollo_profesional/personal"
            >
              Cancelar
            </v-btn>
            <v-btn
              class="ui-module-btn-solid"
              v-bind="primaryButtonProps"
              v-on:click="asignaCup()"
              :loading="loading"
              :disabled="loading"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { primaryButtonProps, secondaryButtonProps } from '../../components/props/props'

export default {
  props: {
    personal: {
      type: Object,
    },
  },

  data() {
    return {
      primaryButtonProps,
      secondaryButtonProps,
      loading: false,
      loadingCups: false,
      cup: '',
      file: null,
      fechaEmisionEvaluacionC3: this.personal ? this.personal.vigenciaEvaluacionC3 : '',
      fechaEmisionFormacionInicial: this.personal ? this.personal.vigenciaFormacionInicial : '',
      fechaEmisionCompetenciasBasicas: this.personal ? this.personal.vigenciaCompetenciasBasicas : '',
      fechaEmisionCup: this.personal ? this.personal.vigenciaCup : '',
      nameRules: [(v) => !!v || 'Este campo es requerido.'],
      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, 'DD/MM/YYYY')
          return moment(date, 'DD/MM/YYYY').isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
    }
  },

  computed: {
    ...mapGetters('respetoPrincipios', {
      latestEvaluacionDesempenioDate: 'getLatestEvaluacionDesempenioDate',
      latestEvaluacionDesempenioCalificacion: 'getLatestEvaluacionDesempenioCalificacion',
    }),
    ...mapGetters('respetoPrincipiosValores', {
      latestEvaluacionAcademicaDate: 'getLatestEvaluacionAcademicaDate',
      latestEvaluacionAcademicaCalificacion: 'getLatestEvaluacionAcademicaCalificacion',
    }),
    ...mapGetters('cups', { cups: 'getCups' }),

    vigenciaEvaluacionC3Calculada() {
      if (!this.fechaEmisionEvaluacionC3) return ''
      const fecha = moment(this.fechaEmisionEvaluacionC3, 'DD/MM/YYYY')
      if (!fecha.isValid()) return ''
      return fecha.add(3, 'years').format('DD/MM/YYYY')
    },
    vigenciaFormacionInicialCalculada() {
      if (!this.fechaEmisionFormacionInicial) return ''
      const fecha = moment(this.fechaEmisionFormacionInicial, 'DD/MM/YYYY')
      if (!fecha.isValid()) return ''
      return fecha.add(3, 'years').format('DD/MM/YYYY')
    },
    vigenciaCompetenciasBasicasCalculada() {
      if (!this.fechaEmisionCompetenciasBasicas) return ''
      const fecha = moment(this.fechaEmisionCompetenciasBasicas, 'DD/MM/YYYY')
      if (!fecha.isValid()) return ''
      return fecha.add(3, 'years').format('DD/MM/YYYY')
    },
    vigenciaCupCalculada() {
      if (!this.fechaEmisionCup) return ''
      const fecha = moment(this.fechaEmisionCup, 'DD/MM/YYYY')
      if (!fecha.isValid()) return ''
      return fecha.add(3, 'years').format('DD/MM/YYYY')
    },
  },

  async mounted() {
    if (this.personal && this.personal.idPersonal) {
      await Promise.all([
        this.fetchRespetoPrincipios(this.personal.idPersonal),
        this.fetchRespetoPrincipiosValores(this.personal.idPersonal),
        this.cargarCups(),
      ])
    }
  },

  methods: {
    ...mapActions('personal', ['updateCupPersonal', 'fetchPersonal', 'updatePersonal', 'uploadCup']),
    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapActions('respetoPrincipiosValores', ['fetchRespetoPrincipiosValores']),
    ...mapActions('cups', ['createCup', 'fetchCupsById']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async cargarCups() {
      this.loadingCups = true
      try {
        await this.fetchCupsById(this.personal.idPersonal)
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al cargar el historial de CUP´s.')
      } finally {
        this.loadingCups = false
      }
    },

    async asignaCup() {
      this.loading = true
      try {
        this.personal.cup = this.cup
        await this.updateCupPersonal(this.personal)

        var formData = new FormData()
        formData.append('file', this.file)
        formData.append('idPersonal', this.personal.idPersonal)
        await this.uploadCup(formData)

        this.personal.vigenciaEvaluacionC3 = this.fechaEmisionEvaluacionC3
        this.personal.vigenciaFormacionInicial = this.fechaEmisionFormacionInicial
        this.personal.vigenciaCompetenciasBasicas = this.fechaEmisionCompetenciasBasicas
        this.personal.vigenciaCup = this.fechaEmisionCup

        await this.updatePersonal(this.personal)

        const cupFormData = new FormData()
        cupFormData.append('cup', this.cup)
        cupFormData.append('vigenciaCup', moment(this.fechaEmisionCup, 'DD/MM/YYYY').format('DD/MM/YYYY HH:mm:ss a'))
        cupFormData.append('observaciones', '')
        cupFormData.append('fk_idPersonal', this.personal.idPersonal)
        if (this.file) {
          cupFormData.append('adjunto', this.file)
        }

        await this.createCup({ idPersonal: this.personal.idPersonal, payload: cupFormData })

        this.$router.push('/desarrollo_profesional/personal')
      } catch (error) {
        console.error('Ocurrió un error al registrar el CUP:', error)
      } finally {
        this.loading = false
      }
    },

    getFullName(personal) {
      if (!personal) return ''
      return `${personal.apaterno} ${personal.amaterno} ${personal.nombre} ${personal.segundoNombre}`
    },

    formatFecha(fecha) {
      if (!fecha) return 'Sin registro'
      if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
        return moment(fecha, 'YYYY-MM-DD').format('DD/MM/YYYY')
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
        return moment(fecha, 'DD/MM/YYYY').format('DD/MM/YYYY')
      }
      return 'Sin registro'
    },
  },
}
</script>

<style scoped>
.summary-card .ui-module-titlebar {
  color: #1a1a1a !important;
}

.summary-card-text {
  color: #1a1a1a !important;
}

.summary-row {
  color: #1a1a1a !important;
}

.info-label {
  color: rgba(26, 26, 26, 0.78) !important;
}

.info-value {
  color: #111111 !important;
}

.summary-divider {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.18) !important;
}

.cup-form-shell {
  color: #e0e0e0;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.22) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  transition: all 0.25s ease !important;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.38) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.48) !important;
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.12) !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .v-icon,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .v-file-input__text {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.68) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field.v-input--is-focused .v-icon {
  color: var(--v-secondary-base) !important;
}
</style>
